const CHANGE_EVENT = 'change';

const createCompatibleMediaQueryList = (mediaQueryList) => {
  if (
    !mediaQueryList
    || typeof mediaQueryList.addListener !== 'function'
    || (
      typeof mediaQueryList.addEventListener === 'function'
      && typeof mediaQueryList.removeEventListener === 'function'
    )
  ) {
    return mediaQueryList;
  }

  const compatible = {
    addEventListener(type, listener) {
      if (type !== CHANGE_EVENT) return;
      if (typeof mediaQueryList.addEventListener === 'function') {
        mediaQueryList.addEventListener(type, listener);
        return;
      }
      mediaQueryList.addListener(listener);
    },
    addListener(listener) {
      return mediaQueryList.addListener(listener);
    },
    removeEventListener(type, listener) {
      if (type !== CHANGE_EVENT) return;
      if (typeof mediaQueryList.removeEventListener === 'function') {
        mediaQueryList.removeEventListener(type, listener);
        return;
      }
      if (typeof mediaQueryList.removeListener === 'function') mediaQueryList.removeListener(listener);
    },
    removeListener(listener) {
      if (typeof mediaQueryList.removeListener === 'function') {
        return mediaQueryList.removeListener(listener);
      }
      return undefined;
    },
  };

  ['matches', 'media', 'onchange'].forEach((property) => {
    Object.defineProperty(compatible, property, {
      configurable: true,
      enumerable: true,
      get: () => mediaQueryList[property],
      set: (value) => {
        mediaQueryList[property] = value;
      },
    });
  });

  return compatible;
};

export const installLegacyMediaQueryCompatibility = (
  windowRef = typeof window !== 'undefined' ? window : null
) => {
  if (!windowRef || typeof windowRef.matchMedia !== 'function') return false;

  let probe;
  try {
    probe = windowRef.matchMedia('all');
  } catch {
    return false;
  }

  if (
    typeof probe?.addEventListener === 'function'
    && typeof probe?.removeEventListener === 'function'
  ) {
    return false;
  }
  if (typeof probe?.addListener !== 'function') return false;

  const originalMatchMedia = windowRef.matchMedia;
  const compatibleMatchMedia = function compatibleMatchMedia(query) {
    return createCompatibleMediaQueryList(originalMatchMedia.call(windowRef, query));
  };

  try {
    windowRef.matchMedia = compatibleMatchMedia;
  } catch {
    return false;
  }

  return windowRef.matchMedia === compatibleMatchMedia;
};
